export function maskCep(value: string): string {
  if (!value) return;
  // Remove tudo que não for número
  const numeric = value.replace(/\D/g, "");

  // Limita a 8 dígitos
  const limited = numeric.slice(0, 8);

  // Aplica a máscara: 00000-000
  if (limited.length <= 5) {
    return limited;
  }

  return `${limited.slice(0, 5)}-${limited.slice(5)}`;
}

export function removeMaskCep(value: string): string {
  return value.replace("-", "");
}
